export function serializedSizeBytes(obj) {
	const str = JSON.stringify(obj)
	// Browser / RN with TextEncoder
	if (typeof TextEncoder !== 'undefined') return new TextEncoder().encode(str).length
	// Node (SSR or tests)
	const maybeBuffer = globalThis?.Buffer
	if (maybeBuffer?.byteLength) return maybeBuffer.byteLength(str, 'utf8')
	// Fallback (approximate)
	return str.length
}

export function formatBytes(bytes) {
	if (bytes < 1024) return `${bytes} B`
	const kb = bytes / 1024
	if (kb < 1024) return `${kb.toFixed(1)} KB`
	const mb = kb / 1024
	return `${mb.toFixed(2)} MB`
}

export function formatStoreSize(state) {
	return formatBytes(serializedSizeBytes(state))
}
